import React from 'react'

import { CLIENTS } from '../../../../../helpers/constants'
import * as InvoicesAndReceiptsHelpers from './helpers'

export const RECEIPT_TABLE_COLUMNS = {
  [CLIENTS.CLEAROUT.NAME]: [
    {
      label: 'Quantity',
      renderCell: InvoicesAndReceiptsHelpers.receiptCreditFormatter,
      order: 1
    },
    {
      label: 'Description',
      renderCell: InvoicesAndReceiptsHelpers.receiptDescriptionFormatter,
      order: 2
    },
    {
      label: 'Billing',
      renderCell: InvoicesAndReceiptsHelpers.receiptBillingFormatter,
      order: 3
    },
    {
      label: 'Payment',
      renderCell: InvoicesAndReceiptsHelpers.receiptPaymentFormatter,
      order: 4
    },
    {
      label:
        <>
          <span>Amount</span>
          <span>(In USD)</span>
        </>,
      renderCell: InvoicesAndReceiptsHelpers.receiptAmountFormatter,
      order: 5
    },
    {
      label: 'Coupon Applied',
      renderCell: InvoicesAndReceiptsHelpers.receiptCouponFormatter,
      order: 6
    },
    {
      label: 'Purchased On',
      renderCell: InvoicesAndReceiptsHelpers.receiptPurchasedFormatter,
      order: 7
    },
    {
      label: 'Type',
      renderCell: InvoicesAndReceiptsHelpers.receiptTypeFormatter,
      order: 8
    },
    {
      label: 'Plan Id',
      renderCell: InvoicesAndReceiptsHelpers.receiptPlanIdFormatter,
      order: 9
    },
    {
      label: 'Payee Info',
      renderCell: InvoicesAndReceiptsHelpers.receiptPayeeInfoFormatter,
      order: 10
    },
    {
      label: 'Payee Address',
      renderCell: InvoicesAndReceiptsHelpers.receiptPayeeAddressFormatter,
      order: 11
    },
  ],
  [CLIENTS.CLEAROUTPHONE.NAME]: [
    {
      label: 'Quantity',
      renderCell: InvoicesAndReceiptsHelpers.receiptCreditFormatter,
      order: 1
    },
    {
      label: 'Description',
      renderCell: InvoicesAndReceiptsHelpers.receiptDescriptionFormatter,
      order: 2
    },
    {
      label: 'Billing',
      renderCell: InvoicesAndReceiptsHelpers.receiptBillingFormatter,
      order: 3
    },
    {
      label: 'Payment',
      renderCell: InvoicesAndReceiptsHelpers.receiptPaymentFormatter,
      order: 4
    },
    {
      label:
        <>
          <span>Amount</span>
          <span>(In USD)</span>
        </>,
      renderCell: InvoicesAndReceiptsHelpers.receiptAmountFormatter,
      order: 5
    },
    {
      label: 'Coupon Applied',
      renderCell: InvoicesAndReceiptsHelpers.receiptCouponFormatter,
      order: 6
    },
    {
      label: 'Purchased On',
      renderCell: InvoicesAndReceiptsHelpers.receiptPurchasedFormatter,
      order: 7
    },
    {
      label: 'Type',
      renderCell: InvoicesAndReceiptsHelpers.receiptTypeFormatter,
      order: 8
    },
    {
      label: 'Plan Id',
      renderCell: InvoicesAndReceiptsHelpers.receiptPlanIdFormatter,
      order: 9
    },
    {
      label: 'Payee Info',
      renderCell: InvoicesAndReceiptsHelpers.receiptPayeeInfoFormatter,
      order: 10
    },
    {
      label: 'Payee Address',
      renderCell: InvoicesAndReceiptsHelpers.receiptPayeeAddressFormatter,
      order: 11
    },
  ],
  [CLIENTS.SPOKESLY_CLEAROUT.NAME]: [
    {
      label: 'Quantity',
      renderCell: InvoicesAndReceiptsHelpers.receiptCreditFormatter,
      order: 1
    },
    {
      label: 'Description',
      renderCell: InvoicesAndReceiptsHelpers.receiptDescriptionFormatter,
      order: 2
    },
    {
      label: 'Billing',
      renderCell: InvoicesAndReceiptsHelpers.receiptBillingFormatter,
      order: 3
    },
    {
      label: 'Payment',
      renderCell: InvoicesAndReceiptsHelpers.receiptPaymentFormatter,
      order: 4
    },
    {
      label:
        <>
          <span>Amount</span>
          <span>(In USD)</span>
        </>,
      renderCell: InvoicesAndReceiptsHelpers.receiptAmountFormatter,
      order: 5
    },
    {
      label: 'Coupon Applied',
      renderCell: InvoicesAndReceiptsHelpers.receiptCouponFormatter,
      order: 6
    },
    {
      label: 'Purchased On',
      renderCell: InvoicesAndReceiptsHelpers.receiptPurchasedFormatter,
      order: 7
    },
    {
      label: 'Type',
      renderCell: InvoicesAndReceiptsHelpers.receiptTypeFormatter,
      order: 8
    },
    {
      label: 'Plan Id',
      renderCell: InvoicesAndReceiptsHelpers.receiptPlanIdFormatter,
      order: 9
    },
    {
      label: 'Payee Info',
      renderCell: InvoicesAndReceiptsHelpers.receiptPayeeInfoFormatter,
      order: 10
    },
    {
      label: 'Payee Address',
      renderCell: InvoicesAndReceiptsHelpers.receiptPayeeAddressFormatter,
      order: 11
    },
  ],
  [CLIENTS.EU_CLEAROUT.NAME]: [
    {
      label: 'Quantity',
      renderCell: InvoicesAndReceiptsHelpers.receiptCreditFormatter,
      order: 1
    },
    {
      label: 'Description',
      renderCell: InvoicesAndReceiptsHelpers.receiptDescriptionFormatter,
      order: 2
    },
    {
      label: 'Billing',
      renderCell: InvoicesAndReceiptsHelpers.receiptBillingFormatter,
      order: 3
    },
    {
      label: 'Payment',
      renderCell: InvoicesAndReceiptsHelpers.receiptPaymentFormatter,
      order: 4
    },
    {
      label:
        <>
          <span>Amount</span>
          <span>(In USD)</span>
        </>,
      renderCell: InvoicesAndReceiptsHelpers.receiptAmountFormatter,
      order: 5
    },
    {
      label: 'Coupon Applied',
      renderCell: InvoicesAndReceiptsHelpers.receiptCouponFormatter,
      order: 6
    },
    {
      label: 'Purchased On',
      renderCell: InvoicesAndReceiptsHelpers.receiptPurchasedFormatter,
      order: 7
    },
    {
      label: 'Type',
      renderCell: InvoicesAndReceiptsHelpers.receiptTypeFormatter,
      order: 8
    },
    {
      label: 'Plan Id',
      renderCell: InvoicesAndReceiptsHelpers.receiptPlanIdFormatter,
      order: 9
    },
    {
      label: 'Payee Info',
      renderCell: InvoicesAndReceiptsHelpers.receiptPayeeInfoFormatter,
      order: 10
    },
    {
      label: 'Payee Address',
      renderCell: InvoicesAndReceiptsHelpers.receiptPayeeAddressFormatter,
      order: 11
    },
  ],
  [CLIENTS.PEPIPOST_CLEAROUT.NAME]: [
    {
      label: 'Quantity',
      renderCell: InvoicesAndReceiptsHelpers.receiptCreditFormatter,
      order: 1
    },
    {
      label: 'Description',
      renderCell: InvoicesAndReceiptsHelpers.receiptDescriptionFormatter,
      order: 2
    },
    {
      label: 'Billing',
      renderCell: InvoicesAndReceiptsHelpers.receiptBillingFormatter,
      order: 3
    },
    {
      label: 'Payment',
      renderCell: InvoicesAndReceiptsHelpers.receiptPaymentFormatter,
      order: 4
    },
    {
      label:
        <>
          <span>Amount</span>
          <span>(In USD)</span>
        </>,
      renderCell: InvoicesAndReceiptsHelpers.receiptAmountFormatter,
      order: 5
    },
    {
      label: 'Coupon Applied',
      renderCell: InvoicesAndReceiptsHelpers.receiptCouponFormatter,
      order: 6
    },
    {
      label: 'Purchased On',
      renderCell: InvoicesAndReceiptsHelpers.receiptPurchasedFormatter,
      order: 7
    },
    {
      label: 'Type',
      renderCell: InvoicesAndReceiptsHelpers.receiptTypeFormatter,
      order: 8
    },
    {
      label: 'Plan Id',
      renderCell: InvoicesAndReceiptsHelpers.receiptPlanIdFormatter,
      order: 9
    },
    {
      label: 'Payee Info',
      renderCell: InvoicesAndReceiptsHelpers.receiptPayeeInfoFormatter,
      order: 10
    },
    {
      label: 'Payee Address',
      renderCell: InvoicesAndReceiptsHelpers.receiptPayeeAddressFormatter,
      order: 11
    },
  ],
  [CLIENTS.CAMS_CLEAROUT.NAME]: [
    {
      label: 'Quantity',
      renderCell: InvoicesAndReceiptsHelpers.receiptCreditFormatter,
      order: 1
    },
    {
      label: 'Description',
      renderCell: InvoicesAndReceiptsHelpers.receiptDescriptionFormatter,
      order: 2
    },
    {
      label: 'Billing',
      renderCell: InvoicesAndReceiptsHelpers.receiptBillingFormatter,
      order: 3
    },
    {
      label: 'Payment',
      renderCell: InvoicesAndReceiptsHelpers.receiptPaymentFormatter,
      order: 4
    },
    {
      label:
        <>
          <span>Amount</span>
          <span>(In USD)</span>
        </>,
      renderCell: InvoicesAndReceiptsHelpers.receiptAmountFormatter,
      order: 5
    },
    {
      label: 'Coupon Applied',
      renderCell: InvoicesAndReceiptsHelpers.receiptCouponFormatter,
      order: 6
    },
    {
      label: 'Purchased On',
      renderCell: InvoicesAndReceiptsHelpers.receiptPurchasedFormatter,
      order: 7
    },
    {
      label: 'Type',
      renderCell: InvoicesAndReceiptsHelpers.receiptTypeFormatter,
      order: 8
    },
    {
      label: 'Plan Id',
      renderCell: InvoicesAndReceiptsHelpers.receiptPlanIdFormatter,
      order: 9
    },
    {
      label: 'Payee Info',
      renderCell: InvoicesAndReceiptsHelpers.receiptPayeeInfoFormatter,
      order: 10
    },
    {
      label: 'Payee Address',
      renderCell: InvoicesAndReceiptsHelpers.receiptPayeeAddressFormatter,
      order: 11
    },
  ],
  [CLIENTS.US_CLEAROUT.NAME]: [
    {
      label: 'Quantity',
      renderCell: InvoicesAndReceiptsHelpers.receiptCreditFormatter,
      order: 1
    },
    {
      label: 'Description',
      renderCell: InvoicesAndReceiptsHelpers.receiptDescriptionFormatter,
      order: 2
    },
    {
      label: 'Billing',
      renderCell: InvoicesAndReceiptsHelpers.receiptBillingFormatter,
      order: 3
    },
    {
      label: 'Payment',
      renderCell: InvoicesAndReceiptsHelpers.receiptPaymentFormatter,
      order: 4
    },
    {
      label:
        <>
          <span>Amount</span>
          <span>(In USD)</span>
        </>,
      renderCell: InvoicesAndReceiptsHelpers.receiptAmountFormatter,
      order: 5
    },
    {
      label: 'Coupon Applied',
      renderCell: InvoicesAndReceiptsHelpers.receiptCouponFormatter,
      order: 6
    },
    {
      label: 'Purchased On',
      renderCell: InvoicesAndReceiptsHelpers.receiptPurchasedFormatter,
      order: 7
    },
    {
      label: 'Type',
      renderCell: InvoicesAndReceiptsHelpers.receiptTypeFormatter,
      order: 8
    },
    {
      label: 'Plan Id',
      renderCell: InvoicesAndReceiptsHelpers.receiptPlanIdFormatter,
      order: 9
    },
    {
      label: 'Payee Info',
      renderCell: InvoicesAndReceiptsHelpers.receiptPayeeInfoFormatter,
      order: 10
    },
    {
      label: 'Payee Address',
      renderCell: InvoicesAndReceiptsHelpers.receiptPayeeAddressFormatter,
      order: 11
    },
  ],
}

export const PENDING_INVOICE_TABLE_COLUMNS = {
  [CLIENTS.CLEAROUT.NAME]: [
    {
      label: 'Renewal Date',
      renderCell: InvoicesAndReceiptsHelpers.pendingInvoiceRenewalDateFormatter,
    },
    {
      label: 'Plan',
      renderCell: InvoicesAndReceiptsHelpers.pendingInvoiceProductNameFormatter,
    },
    {
      label: 'Failure Reason',
      renderCell: InvoicesAndReceiptsHelpers.pendingInvoiceReasonFormatter,
    },
    {
      label: 'Invoices',
      renderCell: InvoicesAndReceiptsHelpers.pendingInvoiceLink,
    }
  ],
  [CLIENTS.CLEAROUTPHONE.NAME]: [
    {
      label: 'Renewal Date',
      renderCell: InvoicesAndReceiptsHelpers.pendingInvoiceRenewalDateFormatter,
    },
    {
      label: 'Plan',
      renderCell: InvoicesAndReceiptsHelpers.pendingInvoiceProductNameFormatter,
    },
    {
      label: 'Failure Reason',
      renderCell: InvoicesAndReceiptsHelpers.pendingInvoiceReasonFormatter,
    },
    {
      label: 'Invoices',
      renderCell: InvoicesAndReceiptsHelpers.pendingInvoiceLink,
    }
  ],
  [CLIENTS.SPOKESLY_CLEAROUT.NAME]: [
    {
      label: 'Renewal Date',
      renderCell: InvoicesAndReceiptsHelpers.pendingInvoiceRenewalDateFormatter,
    },
    {
      label: 'Plan',
      renderCell: InvoicesAndReceiptsHelpers.pendingInvoiceProductNameFormatter,
    },
    {
      label: 'Failure Reason',
      renderCell: InvoicesAndReceiptsHelpers.pendingInvoiceReasonFormatter,
    },
    {
      label: 'Invoices',
      renderCell: InvoicesAndReceiptsHelpers.pendingInvoiceLink,
    }
  ],
  [CLIENTS.PEPIPOST_CLEAROUT.NAME]: [
    {
      label: 'Renewal Date',
      renderCell: InvoicesAndReceiptsHelpers.pendingInvoiceRenewalDateFormatter,
    },
    {
      label: 'Plan',
      renderCell: InvoicesAndReceiptsHelpers.pendingInvoiceProductNameFormatter,
    },
    {
      label: 'Failure Reason',
      renderCell: InvoicesAndReceiptsHelpers.pendingInvoiceReasonFormatter,
    },
    {
      label: 'Invoices',
      renderCell: InvoicesAndReceiptsHelpers.pendingInvoiceLink,
    }
  ]
}

export const INVOICE_AND_RECEIPT_TAB = {
  [CLIENTS.CLEAROUT.NAME]: {
    SHOW_BUTTONS: ['generate_receipt'],
  },
  [CLIENTS.CLEAROUTPHONE.NAME]: {
    SHOW_BUTTONS: ['generate_receipt'],
  },
  [CLIENTS.SPOKESLY_CLEAROUT.NAME]: {
    SHOW_BUTTONS: ['generate_receipt'],
  },
  [CLIENTS.EU_CLEAROUT.NAME]: {
    SHOW_BUTTONS: ['generate_receipt'],
  },
  [CLIENTS.PEPIPOST_CLEAROUT.NAME]: {
    SHOW_BUTTONS: ['generate_receipt'],
  },
  [CLIENTS.CAMS_CLEAROUT.NAME]: {
    SHOW_BUTTONS: ['generate_receipt'],
  },
  [CLIENTS.US_CLEAROUT.NAME]: {
    SHOW_BUTTONS: ['generate_receipt'],
  },
}
